<template>
	<v-expansion-panels v-model="panel" flat accordion>
		<ExpansionPanel :title="'Basics'">
			<SettingSwitch
				:title="'Label'"
				:placeholder="'Type your title here'"
				:switchValue.sync="titleEnabled"
				:textFieldValue.sync="titleValue"
			/>
			<div>
				<div class="field-text">Image settings</div>
				<ButtonGroup
					class="mb-2"
					:class="{ 'is-disabled': loading }"
					small
					:options="imageOptions"
					:selection="imageOption"
					@change-selection="(v) => (imageOption = v)"
				/>

				<div v-if="imageOption === IMAGE_OPTIONS.IMAGE_URL">
					<div class="flex-centerize">
						<CombinedInputFieldDataMenu
							class="width-100"
							:textAreaMode="true"
							:value.sync="imageUrlTextInput"
							:valuesTypes="ITEM_ONLY_ALLOWED_VALUE_TYPES"
						/>
					</div>
					<div class="soft-message font-size-xs mt-1">The image will fit the maximum width of the form and centered if smaller</div>
				</div>
				<div v-else>
					<AppFileUpload
						:uploadedFile="imageUrl"
						:uploadFunc="uploadFunc"
						placeholder="Select your image"
						accept="image/*"
						@onFileUploaded="onFileUploaded"
					/>
				</div>
			</div>
		</ExpansionPanel>
		<ExpansionPanel :title="'Explanations'">
			<SettingSwitch
				:title="'Description'"
				:placeholder="'Type your description here'"
				:switchValue.sync="descriptionEnabled"
				:textFieldValue.sync="descriptionValue"
			/>
		</ExpansionPanel>
	</v-expansion-panels>
</template>

<script>
import { uploadFile } from '@/utils/helpers';

import FieldSettingsMixin, { getComputedMetadataOption } from '@/components/BlockEditorWidget/FieldSettings/FieldSettingsMixin';

import SettingSwitch from '../WidgetSettings/SettingSwitch';
import ExpansionPanel from '../WidgetSettings/ExpansionPanel';
import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import { ITEM_ONLY_ALLOWED_VALUE_TYPES } from '@/components/DataInput/DataInputMenu/helpers/data-input-menu.const.js';

const IMAGE_OPTIONS = {
	IMAGE_URL: 'image-url',
	UPLOADED_IMAGE: 'uploaded-image',
};

export default {
	name: 'ImageDisplayFieldSettings',
	mixins: [FieldSettingsMixin],
	components: {
		SettingSwitch,
		ExpansionPanel,
		CombinedInputFieldDataMenu,
	},
	data() {
		return {
			IMAGE_OPTIONS,
			imageOptions: [
				{
					text: `Url`,
					value: IMAGE_OPTIONS.IMAGE_URL,
				},
				{
					text: `Upload image`,
					value: IMAGE_OPTIONS.UPLOADED_IMAGE,
				},
			],
			imageOption: null,
			loading: false,
			ITEM_ONLY_ALLOWED_VALUE_TYPES,
		};
	},
	computed: {
		widgetID() {
			return this.field?.widget;
		},
		imageUrl: getComputedMetadataOption('image_display_url'),
		isImageUrlFromUploadedFile: getComputedMetadataOption('is_image_url_from_uploaded_file'),
		imageUrlTextInput: {
			get() {
				return this.imageUrl;
			},
			set(value) {
				this.setImageUrl(value);
			},
		},
	},
	methods: {
		async uploadFunc(file) {
			this.loading = true;
			const uploadedFile = await this.uploadFile({
				file,
				widgetId: this.widgetID,
			});
			return uploadedFile;
		},
		onFileUploaded(url) {
			this.imageUrl = url;
			this.isImageUrlFromUploadedFile = true;
		},
		setImageUrl(val) {
			this.imageUrl = val;
			this.isImageUrlFromUploadedFile = false;
		},
		uploadFile({ file, widgetId, onUploadProgress }) {
			return uploadFile({ file, widgetId, onUploadProgress });
		},
	},
	mounted() {
		this.imageOption = this.isImageUrlFromUploadedFile ? IMAGE_OPTIONS.UPLOADED_IMAGE : IMAGE_OPTIONS.IMAGE_URL;
	},
	watch: {
		imageUrl: {
			handler() {
				this.loading = false;
			},
		},
	},
};
</script>

<style scoped lang="scss"></style>
